import { render, staticRenderFns } from "./signsAndActions.vue?vue&type=template&id=13bd64ab&scoped=true&"
import script from "./signsAndActions.vue?vue&type=script&lang=js&"
export * from "./signsAndActions.vue?vue&type=script&lang=js&"
import style0 from "./signsAndActions.vue?vue&type=style&index=0&id=13bd64ab&prod&lang=scss&"
import style1 from "./signsAndActions.vue?vue&type=style&index=1&id=13bd64ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd64ab",
  null
  
)

export default component.exports